import { selectAuthStatus } from "features/auth/selectors";
import { AuthStatus } from "features/auth/types";
import { useTypedSelector } from "hooks/store";

const useAuth = () => {
    const authState = useTypedSelector(selectAuthStatus);

    const isPending = () =>
        [AuthStatus.Uninitialized, AuthStatus.Pending].includes(authState);
    const isAuthenticated = () =>
        [AuthStatus.Authenticated].includes(authState);

    return {
        isPending,
        isAuthenticated
    };
};

export default useAuth;
